module.exports = __webpack_public_path__ + "media/images/furniture-bg-11-c9bdbd3c1fc56c30969a626e20829935.jpg";